import React from 'react'

export const createLessonTourConfig = (t) => {
    return {
        id: 'create-lesson',
        name: t('tour:create_lesson_name'),
        description: t('tour:create_lesson_desc'),
        icon: 'file-add',
        steps: [
            {
                target: '.lesson-create-main-wrap',
                title: t('tour:create_lesson_step_0_title'),
                content: (
                    <div>
                        <p>{t('tour:create_lesson_step_0_content')}</p>
                    </div>
                ),
                placement: 'center',
            },
            {
                target: '[data-tour="lesson-title"]',
                title: t('tour:create_lesson_step_1_title'),
                content: (
                    <div>
                        <p>{t('tour:create_lesson_step_1_content')}</p>
                    </div>
                ),
                placement: 'bottom'
            },
            {
                target: '[data-tour="lesson-cover"]',
                title: t('tour:create_lesson_step_2_title'),
                content: (
                    <div>
                        <p>{t('tour:create_lesson_step_2_content')}</p>
                    </div>
                ),
                placement: 'right'
            },
            {
                target: '[data-tour="lesson-add-page"]',
                title: t('tour:create_lesson_step_3_title'),
                content: (
                    <div>
                        <p>{t('tour:create_lesson_step_3_content')}</p>
                    </div>
                ),
                placement: 'left'
            }
        ]
    }
}
